import React from 'react';
import { Tooltip, IconButton, IconButtonProps } from '@chakra-ui/react';

type IconButtonWithTooltipProps = IconButtonProps & {
    title: string;
};

export function IconButtonWithTooltip({
    title,
    icon,
    colorScheme = 'gray',
    ...rest
}: IconButtonWithTooltipProps) {
    return (
        <Tooltip
            label={title}
            placement="top"
            aria-label={title}
            zIndex={1800}
            hasArrow={true}>
            <IconButton
                icon={icon}
                colorScheme={colorScheme}
                variant="outline"
                size="sm"
                {...rest}
                aria-label={title}
            />
        </Tooltip>
    );
}
